import React from 'react';
import {Table, TableContainer} from "@mui/material";
import {TableStyle} from "../../../styles/components/TableStyle";
import {ErrorBody} from "./body/ErrorBody";
import {LoadingBody} from "./body/LoadingBody";


const CustomSortTable = ({head, body, error, loading, rowsPerPage, columCounter, sticky, style}) => {
	const classes = TableStyle();
	
	return (
		<React.Fragment>
			<TableContainer className={classes.tableContainer} style={style}>
				<Table className={classes.table} stickyHeader={sticky}>
					{head}
					{
						loading ?
							<LoadingBody rowsPerPage={rowsPerPage} columCounter={columCounter}/> :
							error ?
								<ErrorBody columCounter={columCounter} rowsPerPage={rowsPerPage}/> : body
					}
				</Table>
			</TableContainer>
		</React.Fragment>
	);
};

export default React.memo(CustomSortTable)
